import B from './components/B';
import C from './components/C';
import D from './components/D';
import E from './components/E';
import F from './components/F';
import G from './components/G';
import H from './components/H';
import I from './components/I';
import J from './components/J';
import K from './components/K';
import L from './components/L';
import M from './components/M';
import N from './components/N';
import O from './components/O';
import P from './components/P';
import Q from './components/Q';
import { useState, useEffect } from 'react';

export default function IndexDynamic() {
    return (
        <>
            <B />
            <C />
            <D />
            <E />
            <F />
            <G />
            <H />
            <I />
            <J />
            <K />
            <L />
            <M />
            <N />

            <O />
            <P />
            <Q />
        </>
    );
}
